module.exports = __webpack_public_path__ + "img/P150T_weapon_25.311ecf8d.png";